import { styled } from '@mui/system';
import IconButton from '@mui/material/IconButton';

export const ItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 12
  },
  '& .textField': {
    width: 'calc(100% - 46px)',
    minHeight: 72,
    [theme.breakpoints.down('sm')]: {
      minHeight: '100%'
    }
  },
  '& .MuiFormHelperText-root.Mui-error': {
    height: theme.spacing(4),
    marginTop: 0,
    position: 'relative',
    top: -1
  },
  '& .withDescription': {
    width: 'calc(100% - 46px)',
    minHeight: 72,
    '&  > div > div': {
      paddingRight: '0px !important'
    },
    '& input': {
      '&::-webkit-search-cancel-button': {
        width: 18,
        margin: 4,
        height: 18,
        backgroundImage: 'url("data:image/svg+xml,%3Csvg style=\'fill:balck\' xmlns=\'http://www.w3.org/2000/svg\' focusable=\'false\' viewBox=\'0 0 24 24\' aria-hidden=\'true\'%3E%3Cpath d=\'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\'%3E%3C/path%3E%3C/svg%3E%0A")',
        backgroundRepeat: 'no-repeat',
        '&:hover': {
          cursor: 'pointer'
        },
        [theme.breakpoints.down('sm')]: {
          position: 'relative',
          marginRight: 15,
          marginTop: 4
        }
      }
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 46px)',
      minHeight: 'auto',
      '&  > div > div': {
        display: 'flex',
        '& input': {
          width: '100% !important',
          padding: '0 4px !important'
        }
      }
    }
  }
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  top: 10,
  right: 0,
  position: 'absolute',
  [theme.breakpoints.down('sm')]: {
    top: 0,
    bottom: 0
  }
}));
